import { z } from "zod";
import { defineEndpoint, idParamsSchema } from "./endpoint.js";
/**
 * In-app notifications (docs/specs/notifications.md). Stored as `type` + `data`: the Admin turns them into text
 * in the user's language through i18n keys (`notifications.<type>`), so nothing here is user-facing text.
 */
export const IN_APP_NOTIFICATION_TYPES = [
    "role_assigned",
    "stock_negative",
    "pos_sync_stalled",
    "report_ready",
    "report_failed",
    "plan_limit_warning",
    "billing_payment_approved",
    "billing_payment_rejected",
    "billing_dunning",
];
export const inAppNotificationSchema = z.object({
    id: z.uuid(),
    type: z.enum(IN_APP_NOTIFICATION_TYPES),
    data: z.record(z.string(), z.string()),
    /** A relative path in the Admin. */
    link: z.string().nullable(),
    readAt: z.iso.datetime().nullable(),
    createdAt: z.iso.datetime(),
});
export const inAppNotificationListSchema = z.object({
    data: z.array(inAppNotificationSchema),
    nextCursor: z.uuid().nullable(),
    unreadCount: z.number().int(),
});
/** `GET /v1/notifications?unread=true&limit=&cursor=` */
export const inAppNotificationQuerySchema = z.object({
    unread: z.enum(["true", "false"]).optional(),
    limit: z.coerce.number().int().min(1).max(100).default(50),
    cursor: z.uuid().optional(),
});
// Endpoints -------------------------------------------------------------------------------------------------
export const listNotifications = defineEndpoint({
    name: "listNotifications",
    method: "GET",
    path: "/v1/notifications",
    access: { signedIn: true },
    summary: "Your notifications in the current tenant",
    tag: "notifications",
    query: inAppNotificationQuerySchema,
    status: 200,
    response: inAppNotificationListSchema,
});
export const readAllNotifications = defineEndpoint({
    name: "readAllNotifications",
    method: "POST",
    path: "/v1/notifications/read-all",
    access: { signedIn: true },
    summary: "Mark all your notifications read",
    tag: "notifications",
    status: 204,
});
export const readNotification = defineEndpoint({
    name: "readNotification",
    method: "POST",
    path: "/v1/notifications/{id}/read",
    access: { signedIn: true },
    summary: "Mark one of your notifications read",
    tag: "notifications",
    params: idParamsSchema,
    status: 204,
});
//# sourceMappingURL=notifications.js.map